import init from './init';
import state from './state';
import Mirador from "mirador/dist/es/src/";
import miradorImageToolsPlugin from "mirador-image-tools/es/plugins/miradorImageToolsPlugin";

const config = {
    id: "mirador",
    window: {
        imageToolsEnabled: true,
    },
    workspace: {
        allowNewWindows: true,
    },
    thumbnailNavigation: {
        defaultPosition: 'far-right',
        displaySettings: true, // Display the settings for this in WindowTopMenu
        height: 130, // height of entire ThumbnailNavigation area when position is "far-bottom"
        width: 100, // width of one canvas (doubled for book view) in ThumbnailNavigation area when position is "far-right"
    },
};
var plugins = [miradorImageToolsPlugin,]
var mirador = Mirador.viewer(config, plugins)
window.mirador = mirador
export default {
  ...init,
  ...state,
};


